<template>
  <div style="height:100%">
    <Button
      v-if="caseRecordList.length >=2" style="  margin-left:370px ; float: left;"
      class="add-btn" @click="editRecord()"
    >
      修改记录
    </Button>
    <Button
      v-if="infoCtrl && editState" style="margin-right: 10px; margin-left:280px ; float: left;"
      type="primary" class="add-btn"
      @click="preEditRecord"
    >修改</Button>
    <div v-show="showTargetHint" class="target_hint">
      <Icon
        type="ios-alert" size="20"
        color="orange"
      /><span>研发经理还未配置重案信息，暂时无法添加，请与项目经理联系。</span>
    </div>
    <span v-if="configState && !allowEdit" style="color: orange;padding-left: 40px;">* 项目已启用批量诉讼方案，请在诉讼方案管理板块进行批量提交</span>
    <Form
      v-if="!infoCtrl" ref="formValidateRef"
      class="case-form" :disabled="caseState == 'TN' || ( configState && !allowEdit)"
      :model="formValidate" :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="侵权产品">
        <span>{{ formValidate.tortProduct }}</span>
      </FormItem>
      <div v-if="importantCase">
        <span class="change_style">重案研发意见</span>
        <FormItem label="重案级别"><span>{{ optionData.level }}</span></FormItem>
        <FormItem label="补证意见"><span class="suggestion_top">{{ optionData.additionalEvidSuggest }}</span></FormItem>
        <FormItem label="诉讼策略"><span class="suggestion_top">{{ optionData.litigationStrategy }}</span></FormItem>
        <FormItem label="风险提示"><span class="suggestion_top">{{ optionData.riskWarning }}</span></FormItem>
        <FormItem label="附件"><file-upload :default-list="optionData.attachmentList" :upload-config="{ readOnly: true }" />
        </FormItem>
      </div>
      <FormItem label="案由" prop="programReasonList">
        <Select
          v-model="formValidate.programReasonList" multiple
          placeholder="请选择案由" @on-change="causeActionChange"
        >
          <Option
            v-for="item in ipArr" :key="item.id"
            :value="item.value"
          >
            {{ item.nameZh }}
          </Option>
        </Select>
      </FormItem>
      <FormItem
        label="侵权权利" prop="programRightsList"
        :rules="
          formValidate.programReasonList.length === 1 && formValidate.programReasonList.includes('O') ?
            [{type: 'array'}] : [{ required:true, type: 'array', message: '侵权权利不能为空', trigger: 'change' }]"
      >
        <Select
          v-if="detailsCtrl" v-model="formValidate.programRightsList"
          multiple placeholder="请选择侵权权利"
        >
          <OptionGroup v-if="programRightsArrP.length > 0 && formValidate.programReasonList.indexOf('P') != -1" label="专利">
            <Option
              v-for="item in programRightsArrP" :key="item.name"
              :value="item.id" :label="item.ipNumber"
              :tag="item.ipNumber"
            >
              <div>{{ item.name }}--{{ item.ipNumber }}</div>
              <div>{{ item.ipSpecialTypeZh }}</div>
            </Option>
          </OptionGroup>
          <OptionGroup v-if="programRightsArrT.length > 0 && formValidate.programReasonList.indexOf('T') != -1" label="商标">
            <Option
              v-for="item in programRightsArrT" :key="item.name"
              :value="item.id" :label="item.ipNumber"
              :tag="item.ipNumber"
            >
              <div>{{ item.name }}--{{ item.ipNumber }}</div>
              <div>{{ item.ipSpecialTypeZh }}</div>
            </Option>
          </OptionGroup>
          <OptionGroup v-if="programRightsArrC.length > 0 && formValidate.programReasonList.indexOf('C') != -1" label="著作权">
            <Option
              v-for="item in programRightsArrC" :key="item.name"
              :value="item.id" :label="item.ipNumber"
              :tag="item.ipNumber"
            >
              <div>{{ item.name }}--{{ item.ipNumber }}</div>
              <div>{{ item.ipSpecialTypeZh }}</div>
            </Option>
          </OptionGroup>
          <OptionGroup v-if="programRightsArrO.length > 0 && formValidate.programReasonList.indexOf('O') != -1" label="不正当竞争">
            <Option
              v-for="item in programRightsArrO" :key="item.name"
              :value="item.id" :label="item.ipNumber"
              :tag="item.ipNumber"
            >
              <div>{{ item.name }}--{{ item.ipNumber }}</div>
              <div>{{ item.ipSpecialTypeZh }}</div>
            </Option>
          </OptionGroup>
        </Select>
      </FormItem>
      <FormItem label="对方当事人" prop="litigantIdList">
        <Select
          v-model="formValidate.litigantIdList" multiple
          placeholder="请选择对方当事人"
        >
          <Option
            v-for="item in litigantIdArr" :key="item.id"
            :value="item.id" :label="item.name"
            :tag="item.name"
          >
            <div class="litigant-info textover">名称：{{ item.name }} --- 法人：{{ item.legalRepresentative }}</div>
            <div>地址：{{ item.provinceName }}{{ item.cityName }}{{ item.areaName }}{{ item.address }}</div>
            <div>类型：{{ item.categoryName }}</div>
          </Option>
        </Select>
      </FormItem>
      <FormItem label="代理律师" prop="lawyerIdList">
        <Select
          v-model="formValidate.lawyerIdList" multiple
          placeholder="请选择代理律师"
        >
          <Option
            v-for="item in lawyerArr" :key="item.id"
            :value="item.id"
          >{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem v-show="crimeCase" label="建议起诉标的">
        <span>{{ minAmount }}元-{{ maxAmount }}元</span>
      </FormItem>
      <FormItem label="诉讼标的" prop="amount">
        <my-input
          v-if="detailsCtrl" append-text="￥"
          :default-data="formValidate.amount" :to-fixed="2"
          @getValue="getInputValue($event, 'amount')"
        />
        <span v-if="targetLow" class="show">* 诉讼标的低于起诉标的，建议与项目经理沟通后再填写</span>
        <span v-if="targetHigh" class="show">* 诉讼标的高于起诉标的，建议与项目经理沟通后再填写</span>
      </FormItem>
      <FormItem
        label="合理支出" prop="reasonable"
        :rules="[{ validator: isOverMoney, trigger: 'blur' }]"
      >
        <my-input
          v-if="detailsCtrl" append-text="￥"
          :default-data="formValidate.reasonable" :to-fixed="2"
          @getValue="getInputValue($event, 'reasonable')"
        />
      </FormItem>
      <FormItem
        v-if="false" label="管辖法院区域"
        prop="province"
      >
        <City
          v-if="detailsCtrl" ref="transEvent"
          :city-list="cityList" style="width:100%;"
          @listenCity="getCity"
        />
      </FormItem>
      <FormItem label="管辖法院" prop="courtId">
        <mySelect
          v-if="!infoCtrl" ref="courtSelect"
          :path="'/report/courts'" :placeholder="'请选择管辖法院'"
          :placeholder-input="'请输入管辖法院'" :default-obj="defaultCourt"
          :key-name="'name'" :is-load="false"
          @getValue="getCourtId"
        />
      </FormItem>
      <FormItem
        v-for="(item, index) in materialTypeArr" :key="index"
        :label="item.nameZh" :prop="item.value + 'attachs'"
        :rules="ruleValidate.subject"
      >
        <file-upload
          :default-list="defaultList[item.value + 'attachs'] || []" :upload-config="{}"
          @getFileList="getAttachmentList($event, item.value)"
        />
      </FormItem>
      <FormItem label="主体材料" prop="isMainMaterial">
        <Checkbox v-model="formValidate.isMainMaterial" />
      </FormItem>
      <FormItem label="加盖私章" prop="personalSeal">
        <Checkbox v-model="formValidate.personalSeal" />
      </FormItem>
      <Row class="detail-btn-box">
        <Button
          type="primary" style="margin-right:10px;"
          :disabled="isSubmit" @click="submitLawsuitPlan"
        >保存</Button>
        <Button @click="getLawsuitPlanInfo()">取消</Button>
      </Row>
    </Form>
    <Row v-if="infoCtrl" class="detail-content">
      <Row>
        <Col span="5" class="left-label">侵权产品：</Col>
        <Col span="16" class="right-content">{{ lawsuitPlanInfo.tortProduct }}</Col>
      </Row>
      <Row v-if="importantCase">
        <Row>
          <Col
            span="5" class="left-label"
            style="color:#cc0000;marginLeft:10px"
          >重案研发意见</Col>
          <Col span="16" class="right-content" />
        </Row>
        <Row>
          <Col span="5" class="left-label">重案级别</Col>
          <Col span="16" class="right-content">{{ optionData.level }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">补证意见</Col>
          <Col span="16" class="right-content suggestion">{{ optionData.additionalEvidSuggest }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">诉讼策略</Col>
          <Col span="16" class="right-content suggestion">{{ optionData.litigationStrategy }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">风险提示</Col>
          <Col span="16" class="right-content suggestion">{{ optionData.riskWarning }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">附件</Col>
          <Col span="16" class="right-content"><file-upload :default-list="optionData.attachmentList" :upload-config="{ readOnly: true }" /></Col>
        </Row>
      </Row>
      <Row>
        <Col span="5" class="left-label">案由：</Col>
        <Col span="16" class="right-content">{{ programReason }}</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">侵权权利：</Col>
        <Col span="16" class="right-content">{{ ipRights }}</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">对方当事人：</Col>
        <Col span="16" class="right-content">{{ litigant }}</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">代理律师：</Col>
        <Col span="16" class="right-content">{{ lawyers }}</Col>
      </Row>
      <Row v-show="crimeCase">
        <Col span="5" class="left-label">建议起诉标的</Col>
        <Col span="16" class="right-content">{{ minAmount }}元-{{ maxAmount }}元</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">诉讼标的：</Col>
        <Col span="16" class="right-content">{{ common.formateNumber(lawsuitPlanInfo.amount) }}</Col>
      </Row>
      <Row v-if="targetLow || targetHigh">
        <Col span="5" class="left-label" />
        <Col
          v-if="targetLow" span="16"
          class="right-content" style="color:red;"
        >诉讼标的低于建议起诉标的</Col>
        <Col
          v-if="targetHigh" span="16"
          class="right-content" style="color:red;"
        >诉讼标的高于建议起诉标的</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">合理支出：</Col>
        <Col span="16" class="right-content">{{ common.formateNumber(lawsuitPlanInfo.reasonable) }}</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">管辖法院：</Col>
        <Col span="16" class="right-content">{{ lawsuitPlanInfo.courtJurisdiction }}</Col>
      </Row>
      <Row v-for="(item, index) in lawsuitPlanInfo.caseProgramWritList" :key="index">
        <Col span="5" class="left-label">{{ item.name }}：</Col>
        <Col span="16" class="right-content">
          <file-upload :default-list="item.attachmentList || []" :upload-config="{ readOnly: true }" />
        </Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">主体材料：</Col>
        <Col span="16" class="right-content">{{ lawsuitPlanInfo.isMainMaterial ? '有' : '无' }}</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">加盖私章：</Col>
        <Col span="16" class="right-content">{{ lawsuitPlanInfo.personalSeal ? '是' : '否' }}</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">审核状态：</Col>
        <Col span="16" class="right-content">
          <Tag style="border-radius:11px;" :color="getTagColor(lawsuitPlanInfo.state, lawsuitPlanInfo.reviewState)">
            <span v-if="lawsuitPlanInfo.state == 'P'">待审核</span>
            <span v-if="lawsuitPlanInfo.state == 'E' && lawsuitPlanInfo.reviewState != 'R' && lawsuitPlanInfo.reviewState != 'E'">项目经理审核通过</span>
            <span v-if="lawsuitPlanInfo.reviewState == 'E'">研发经理审核通过</span>
            <span v-if="lawsuitPlanInfo.state == 'R' || lawsuitPlanInfo.reviewState == 'R'">审核驳回</span>
          </Tag>
        </Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">申请用印状态：</Col>
        <Col span="16" class="right-content">
          <Tag :color="lawsuitPlanInfo.sealApplyStatus?'blue':'orange'">{{ lawsuitPlanInfo.sealApplyStatus ? '已申请用印' : '未申请用印' }}</Tag>
        </Col>
      </Row>
      <Row v-if="lawsuitPlanInfo.state == 'R'">
        <Col span="5" class="left-label">审核备注：</Col>
        <Col span="16" class="right-content">{{ lawsuitPlanInfo.auditRemark }}</Col>
      </Row>
    </Row>
    <!-- 修改记录 -->
    <Drawer
      v-model="editRecordCtrl" width="900"
      :styles="{padding:'0px'}" :mask-style="{background:'rgba(0,0,0,0)'}"
    >
      <div slot="header" class="drawer-title">修改记录</div>
      <Tabs :value="activeTab">
        <TabPane
          v-for="(item, index) in caseRecordList" :key="index"
          :label="item.tabName" :name="item.tabName"
        >
          <edit-record-list :case-detail="item.caseDetail" />
        </TabPane>
      </Tabs>
    </Drawer>
    <!-- 修改诉讼方案 -->
    <Modal
      v-model="editNarrativeCtrl" :title="'修改诉讼方案'"
      :width="450" :footer-hide="true"
    >
      <Form
        ref="editNarrativeFormRef" :model="editNarrativeForm"
        :label-width="230"
      >
        <FormItem label="是否需要重新申请盖章起诉材料" prop="caseCategory">
          <RadioGroup v-model="editNarrativeForm.narrativeType">
            <Radio :label="0">否</Radio>
            <Radio :label="1">是</Radio>
          </RadioGroup>
        </FormItem>
      </Form>

      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button type="primary" @click="handleSubmit()">
          确认
        </Button>
        <Button style="margin-left: 8px" @click="editNarrativeCtrl = false">取消</Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
import EditRecordList from '@/view/civilCase/lawsuitProgramme/lawsuitPlan/editRecordList.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    EditRecordList
  },
  props: ['processId', 'caseId', 'projectId', 'editState', 'caseState'],
  data() {
    const isOverMoney = (rule, value, callback) => {
      const key = rule.fullField
      if (this.formValidate[key] && Number(this.formValidate[key]) > 100000000) {
        return callback(new Error('金额不能超过一亿'))
      }
      callback()
    }
    const isFillIn = (rule, value, callback) => {
      const key = rule.fullField
      if (this.formValidate[key] && this.formValidate[key].length > 0) {
        return callback()
      }
      return callback(new Error('请上传附件'))
    }
    return {
      styles: styles,
      isOverMoney: isOverMoney,
      showTargetHint: false,
      targetLow: false,
      targetHigh: false,
      crimeCase: false, // 是否是重案且诉讼标的不在范围
      importantCase: false,
      editRecordCtrl: false,
      optionData: '',
      maxAmount: '',
      minAmount: '',
      ipArr: [], // 案由
      litigantIdArr: [], // 对方当事人
      programRightsArr: [], // 侵权权利
      lawyerArr: [], // 代理律师
      cityList: [],
      defaultList: {},
      materialTypeArr: [],
      formValidate: {
        tortProduct: '',
        programReasonList: [],
        programRightsList: [],
        litigantIdList: [],
        amount: '',
        reasonable: '',
        lawyerIdList: [],
        courtId: '',
        isMainMaterial: true,
        personalSeal: false
      },
      ruleValidate: {
        programReasonList: [{ required: true, type: 'array', message: '案由不能为空', trigger: 'change' }],
        // programRightsList: [{ required: this.formValidate.programReasonList.indexOf('U') !== -1, type: 'array', message: '侵权权利不能为空', trigger: 'change' }],
        litigantIdList: [{ required: true, type: 'array', message: '对方当事人不能为空', trigger: 'change' }],
        amount: [{ required: true, message: '诉讼标的不能为空', trigger: 'blur' }, { validator: isOverMoney, trigger: 'blur' }],
        courtId: [{ required: true, type: 'number', message: '管辖法院不能为空', trigger: 'change' }],
        subject: [{ required: true, validator: isFillIn, trigger: 'blur' }]
      },
      detailsCtrl: false,
      isSubmit: false,
      editId: '',
      defaultCourt: {},
      caseRecordList: [],
      activeTab: null,
      infoCtrl: true,
      lawsuitPlanInfo: '',
      configState: false,
      allowEdit: false,
      editNarrativeCtrl: false,
      editNarrativeForm: {
        narrativeType: 0
      }
    }
  },
  computed: {
    // ...mapGetters(['qccData']),
    programRightsArrP() {
      return (this.programRightsArr.filter(item => {
        if (item.ipType === 'P') {
          return item
        }
      }))
    },
    programRightsArrC() {
      return (this.programRightsArr.filter(item => {
        if (item.ipType === 'C') {
          return item
        }
      }))
    },
    programRightsArrT() {
      return (this.programRightsArr.filter(item => {
        if (item.ipType === 'T') {
          return item
        }
      }))
    },
    programRightsArrO() {
      return (this.programRightsArr.filter(item => {
        if (item.ipType === 'O') {
          return item
        }
      }))
    },
    programReason() {
      let str = ''
      this.lawsuitPlanInfo.programReasonList ? this.lawsuitPlanInfo.programReasonList.map(item => {
        str += item.name + ','
      }) : ''
      return str.slice(0, -1)
    },
    ipRights() {
      let str = ''
      this.lawsuitPlanInfo.ipRightsList ? this.lawsuitPlanInfo.ipRightsList.map(item => {
        str += item.name + ','
      }) : ''
      return str.slice(0, -1)
    },
    litigant() {
      let str = ''
      this.lawsuitPlanInfo.litigantList ? this.lawsuitPlanInfo.litigantList.map(item => {
        str += item.name + ','
      }) : ''
      return str.slice(0, -1)
    },
    lawyers() {
      let str = ''
      this.lawsuitPlanInfo.lawyerList ? this.lawsuitPlanInfo.lawyerList.map(item => {
        str += item.name + ','
      }) : ''
      return str.slice(0, -1)
    }
  },
  watch: {
    // qccData(v) {
    //   console.log(v, 'qccData')
    // },
    // infoCtrl(v) {
    //   if (!v) {
    //     this.$nextTick(() => {
    //       this.$get('/report/courts?current=1&size=15&keyword=' + '佛山市禅城区人民法院').then((res) => {
    //         if (res.code === 0 && res.data && res.data.records && res.data.records.length) {
    //           console.log(res)
    //           this.defaultCourt = {
    //             id: res.data.records[0].id,
    //             name: res.data.records[0].name
    //           }
    //           this.$nextTick(() => {
    //             this.$refs.courtSelect && this.$refs.courtSelect.voluation()
    //           })
    //         }
    //       }).catch((err) => {
    //         console.error(err)
    //       })
    //     })
    //   }
    // }
  },
  created() { },
  async beforeMount() {
    await this.getLawsuitPlanInfo()
    this.getEditRecord()
    if (!this.lawsuitPlanInfo) {
      this.getConfigState()
      this.getHasRecord()
    }
    this.getDictionary()
    this.getTortProduct()
    this.getLitigantIdArr()
    this.getIpRights()
    this.getLawyers()
  },
  mounted() {
    this.getTarget()
  },
  updated() { },
  methods: {
    preEditRecord() {
      this.editNarrativeForm.narrativeType = 0
      if (this.lawsuitPlanInfo.state === 'E') {
        this.editNarrativeCtrl = true
      } else {
        // 开启编辑操作
        this.getLawsuitPlanInfo('edit')
      }
    },
    handleSubmit() {
      this.editNarrativeCtrl = false
      if (this.editNarrativeForm.narrativeType === 0) {
        // 选择否，开启编辑操作
        this.getLawsuitPlanInfo('edit')
      } else {
        this.getCaseData()
          .then((isExistTemplate) => {
            if (isExistTemplate) {
              // 选择是，并且查询文书模板有值，增加提示
              this.$Message.warning('案件已流入诉讼方案管理-未提交（已配置模板）列表中')
              this.$router.push({
                path: '/actionPlan/unSubmitted'
              })
            } else {
              // 选择是，并且查询文书模板为空，开启编辑操作
              this.getLawsuitPlanInfo('edit')
            }
          })
      }
    },
    getCaseData() {
      console.log('this.lawsuitPlanInfo=', this.lawsuitPlanInfo)
      return new Promise((resolve, reject) => {
        const url = '/business/case/chek-redo-program'
        const litigantIdList = this.lawsuitPlanInfo.litigantIdList = this.lawsuitPlanInfo.litigantList ? this.lawsuitPlanInfo.litigantList.map(item => {
          return item.id
        }) : []
        const ajaxData = {
          caseId: this.caseId,
          id: this.lawsuitPlanInfo.id,
          litigantIdList
        }
        this.$post(url, ajaxData)
          .then(res => {
            if (res.code == 0) {
              resolve(res.data)
            } else {
              this.$Message.error(res.message || '接口发生异常')
              reject()
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            reject()
          })
      })
    },
    editRecord() {
      this.editRecordCtrl = true
      this.activeTab = this.caseRecordList.length !== 0 ? this.caseRecordList[0].tabName : null
    },
    getEditRecord() {
      const url = `/business/case/program/log/${this.caseId}`
      this.$get(url)
        .then(res => {
          if (res.code === 0) {
            this.caseRecordList = this.caseRecordListFormat(res.data)
          }
        })
    },
    caseRecordListFormat(data) {
      if (!data) return []
      return data.map((item, index) => {
        const tabName = `${index + 1}.${this.common.formatTime(item.logTime, 4)} 诉讼方案`
        return {
          tabName,
          caseDetail: item
        }
      })
    },
    // 案由选择事件
    causeActionChange(selectedValArr) {
      const that = this
      const deleteProgramRightKeysArr = []
      // 全部侵权权利数组映射
      const allProgramRightsObj = {
        'P': that.programRightsArrP,
        'T': that.programRightsArrT,
        'C': that.programRightsArrC,
        'O': that.programRightsArrO
      }
      // 找出需要清除侵权权利对应的key
      Object.keys(allProgramRightsObj).forEach(item => {
        !selectedValArr.includes(item) && deleteProgramRightKeysArr.push(item)
      })
      // 清除选择的案由时，清除已选择的关联的侵权权利
      deleteProgramRightKeysArr.forEach(item => {
        const targetProgramRight = allProgramRightsObj[item]
        targetProgramRight.forEach(subItem => {
          const deleteIdx = this.formValidate.programRightsList.indexOf(subItem.id)
          if (deleteIdx !== -1) {
            this.formValidate.programRightsList.splice(deleteIdx, 1)
          }
        })
      })
    },
    // 获取案件所属项目是否启用了批量诉讼方案
    getConfigState() {
      const url = `/business/project/litigation-plan/config/state/${this.caseId}`
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.configState = res.data
        }
      })
    },
    // 获取案件所属项目是否启用了批量诉讼方案
    getHasRecord() {
      const url = `/business/case/payment-record/has-record/${this.caseId}`
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.allowEdit = res.data
        }
      })
    },
    getAttachmentList(arr, key) {
      this.formValidate[key + 'attachs'] = []
      arr.forEach((item) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidate[key + 'attachs'].push(obj)
      })
    },
    // 获取详情
    async getLawsuitPlanInfo(type) {
      const url = '/business/case/program/' + this.processId
      await this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          this.editId = res.data.id
          this.lawsuitPlanInfo = res.data
          this.$emit('getAuditState', true)
          this.infoCtrl = type !== 'edit'
          if (this.maxAmount && this.minAmount) {
            this.targetLow = false
            this.targetHigh = false
            if (res.data.amount > this.maxAmount) {
              this.targetHigh = true
            } else if (res.data.amount < this.minAmount) {
              this.targetLow = true
            } else {
              this.targetLow = false
              this.targetHigh = false
            }
          }
          if (type === 'edit') {
            this.getDetail(this.lawsuitPlanInfo)
          }
        } else {
          this.$emit('getAuditState', false)
          this.editId = ''
          this.infoCtrl = false
          this.detailsCtrl = true
        }
      })
    },
    getOpinion() {
      const url = `/business/serious/case/info/` + this.caseId
      this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          this.optionData = res.data
        }
      })
    },
    getTarget() {
      const url = '/business/case/' + this.caseId + '/lawyer'
      this.$get(url).then(res => {
        if (res.code === 0) {
          if (res.data.caseCategory === 'I') {
            this.importantCase = true
            this.getOpinion()
          }
          if (res.data.caseCategory === 'I' && res.data.seriousCaseLevel !== 'D' && !res.data.maxAmount && !res.data.minAmount) {
            this.isSubmit = true
            this.showTargetHint = true
          }
          if (res.data.caseCategory === 'I' && res.data.seriousCaseLevel !== 'D' && res.data.maxAmount && res.data.minAmount) {
            this.crimeCase = true
            this.maxAmount = res.data.maxAmount
            this.minAmount = res.data.minAmount
          }
        }
      })
    },
    getInputValue(data, name) {
      this.formValidate[name] = data
      this.targetLow = false
      this.targetHigh = false
      if (this.minAmount && this.maxAmount && this.formValidate[name] && name === 'amount') {
        if (this.formValidate[name] > this.maxAmount && this.formValidate[name] < 100000000) {
          this.targetHigh = true
        } else if (this.formValidate[name] < this.minAmount) {
          this.targetLow = true
        } else {
          this.targetLow = false
          this.targetHigh = false
        }
      }
    },
    getTagColor(state, reviewState) {
      if (state === 'P') {
        const obj = {
          'P': styles.warningColor
        }
        return obj[state]
      }
      if (state === 'E' && (reviewState === 'P' || !reviewState)) {
        const obj = {
          'E': styles.infoColor
        }
        return obj[state]
      }
      if ((state === 'E' && reviewState === 'R') || state === 'R') {
        const obj = {
          'R': styles.errorColor
        }
        return obj[reviewState] || obj[state]
      }
      if (reviewState === 'E') {
        const obj = {
          'E': styles.successColor
        }
        return obj[reviewState]
      }
    },
    // 提交
    submitLawsuitPlan() {
      this.$refs['formValidateRef'].validate((valid) => {
        if (valid) {
          const url = '/business/case/program'
          const ajaxData = {}
          Object.assign(ajaxData, this.formValidate)
          ajaxData.programReasonList = ajaxData.programReasonList.length > 0 ? ajaxData.programReasonList.map(item => {
            return { code: item }
          }) : []
          ajaxData.programRightsList = ajaxData.programRightsList.length > 0 ? ajaxData.programRightsList.map(item => {
            return { rightsId: item }
          }) : []
          ajaxData.processId = this.processId
          ajaxData.caseId = this.caseId
          ajaxData.caseProgramWritList = []
          this.materialTypeArr.forEach((item, index) => {
            const arr = this.formValidate[item.value + 'attachs']
            if (arr && arr.length > 0) {
              const obj = {
                type: item.value,
                name: item.nameZh,
                attachmentList: arr
              }
              ajaxData.caseProgramWritList.push(obj)
            }
          })
          this.isSubmit = true
          if (this.editId) {
            ajaxData.id = this.editId
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.getLawsuitPlanInfo()
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message || '操作失败')
              }
            })
          } else {
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.getLawsuitPlanInfo()
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message || '操作失败')
              }
            })
          }
        }
      })
    },
    // 赋值
    getDetail(data) {
      this.editId = data.id
      this.formValidate.tortProduct = data.tortProduct
      this.formValidate.programReasonList = data.programReasonList ? data.programReasonList.map(item => {
        return item.code
      }) : []
      this.formValidate.programRightsList = data.ipRightsList ? data.ipRightsList.map(item => {
        return item.id
      }) : []
      this.formValidate.litigantIdList = data.litigantList ? data.litigantList.map(item => {
        return item.id
      }) : []
      this.formValidate.amount = data.amount
      this.formValidate.reasonable = data.reasonable
      this.formValidate.lawyerIdList = data.lawyerList ? data.lawyerList.map(item => {
        return item.id
      }) : []
      this.formValidate.courtId = Number(data.courtId)
      this.defaultCourt = {
        name: data.courtJurisdiction,
        id: Number(data.courtId)
      }
      this.$nextTick(function () {
        if (!this.infoCtrl) {
          this.$refs.courtSelect.voluation()
        }
      })
      data.caseProgramWritList.forEach((item, index) => {
        const key = item.type + 'attachs'
        this.$set(this.formValidate, key, [])
        this.$set(this.defaultList, key, [])
        item.attachmentList.forEach((attItem) => {
          const obj = {
            fileName: attItem.fileName,
            mediaType: attItem.mediaType,
            smallUrl: attItem.smallUrl,
            url: attItem.url
          }
          this.formValidate[key].push(obj)
          this.defaultList[key].push(obj)
        })
      })
      this.formValidate.isMainMaterial = data.isMainMaterial
      this.formValidate.personalSeal = data.personalSeal
      this.detailsCtrl = true
    },
    // 搜索条件省市区接口
    getCity(data) {
      let area
      if (data.length !== 0) {
        if (data.length === 1) {
          this.formValidate.province = data[0].value
          this.formValidate.city = ''
          this.formValidate.area = ''
          area = data[0].label
        } else if (data.length === 2) {
          this.formValidate.province = data[0].value
          this.formValidate.city = data[1].value
          this.formValidate.area = ''
          area = data[0].label + data[1].label
        } else if (data.length === 3) {
          this.formValidate.province = data[0].value
          this.formValidate.city = data[1].value
          this.formValidate.area = data[2].value
          area = data[0].label + data[1].label + data[2].label
        }
      } else {
        this.formValidate.province = ''
        this.formValidate.city = ''
        this.formValidate.area = ''
        area = ''
      }
    },
    // 获取侵权产品
    getTortProduct() {
      const url = `/business/case/program/${this.caseId}/product-name`
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.formValidate.tortProduct = res.data
        }
      })
    },
    // 获取侵权权利
    getIpRights() {
      const url = '/business/ipRights?projectId=' + this.projectId
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.programRightsArr = res.data
        }
      })
    },
    // 获取对方当事人
    getLitigantIdArr() {
      const url = '/business/litigants/lawyer?caseId=' + this.caseId
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.litigantIdArr = res.data.filter(item => {
            if (item.auditState === 'E') {
              return item
            }
          })
        }
      })
    },
    // 获取代理律师
    getLawyers() {
      const url = '/base/lawyers/login-team-member'
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.lawyerArr = res.data
        }
      })
    },
    // 获取管辖法院
    getCourtId(data) {
      this.formValidate.courtId = data.id
    },
    // 获取字典数据接口
    async getDictionary() {
      this.ipArr = await this.common.getDictionaryItems('ip_type')
      this.materialTypeArr = await this.common.getDictionaryItems('writ_type')
    }
  }
}
</script>
<style scoped lang="scss">
@import '../caseCommon.scss';

.litigant-info {
  width: 100%;
}

.add-btn {
  margin-top: -64px;
}

.show {
  color: red;
  position: relative;
  top: 0;
  left: 0;
}

.target_hint {
  color: orange;
  margin-left: 35px;
  line-height: 24px;

  span {
    padding-left: 3px;
  }
}

.change_style {
  color: #cc0000;
  position: relative;
  top: -5px;
  left: 38px;
}

.suggestion,
.suggestion_top {
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;

  &:hover {
    text-overflow: clip;
    white-space: pre-line;
    overflow: visible;
    -o-text-overflow: visible;
  }
}

.suggestion_top {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/lawsuitProgramme/lawsuitPlan.vue